import { render, staticRenderFns } from "./Classification.vue?vue&type=template&id=1acac908&scoped=true&"
import script from "./Classification.vue?vue&type=script&lang=js&"
export * from "./Classification.vue?vue&type=script&lang=js&"
import style0 from "./Classification.vue?vue&type=style&index=0&id=1acac908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acac908",
  null
  
)

export default component.exports